<template>
    <ListEditForm
        :form-component="LanguageForm"
        inline
        :new-item-generator="newLanguage"
        new-item-label="Pridať jazyk"
        :value="value"
        v-bind="$attrs"
        @input="$emit('update:model-value', $event)"
    />
</template>

<script setup lang="ts">
import { DEFAULT_LANGUAGE } from '#shared/constants/language'
import type { Language } from '#shared/types/Language'
import LanguageForm from '@/components/profile/LanguageForm.vue'
import ListEditForm from '@/components/profile/ListEditForm.vue'

defineProps<{
    value: Language[]
}>()

defineEmits<{
    'update:model-value': [value: Language[]]
}>()

// Create a function to generate new language objects
const newLanguage = () => ({ ...DEFAULT_LANGUAGE })
</script>